import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface SalarySetupProps {
  onBack: () => void;
}

const SalarySetup = ({ onBack }: SalarySetupProps) => {
  return (
    <div className="space-y-6 w-full max-w-full">
      {/* Header */}
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="sm" onClick={onBack} className="p-0 hover:bg-transparent">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Payroll
        </Button>
      </div>

      <div className="p-8 border rounded-lg border-dashed text-center text-muted-foreground">
        <h3 className="text-lg font-medium mb-2">Salary Setup Page</h3>
        <p>This page is currently empty. Functionality to be specified later.</p>
      </div>
    </div>
  );
};

export default SalarySetup;
